import $t from '@Ravnur-Inc/l10n/$t';
import { Vue } from 'vue-class-component';

import RavTable, { TableCellDescription } from '@/components/rav-table/rav-table';

import { Media$Quality } from '@/types/Media';

import './media-qualities-table.scss';

const CN = 'media-qualities-table';

class Props {
  list: Media$Quality[];
}

export default class MediaQualitiesTable extends Vue.with(Props) {
  private get descriptions(): Array<TableCellDescription<Media$Quality>> {
    return [
      { key: 'quality', label: $t('media', 'download__quality-header') },
      { key: 'format', label: $t('media', 'download__format-header') },
      {
        key: 'size',
        label: $t('media', 'download__size-header'),
        align: 'left',
      },
      {
        key: 'src',
        label: $t('media', 'download__action-header'),
        align: 'right',
      },
    ];
  }

  render() {
    const slots = {
      src: this.renderDownloadButton,
    };

    return (
      <RavTable class={CN} descriptions={this.descriptions} list={this.list} v-slots={slots} />
    );
  }

  private renderDownloadButton({ item: q }: { item: Media$Quality }) {
    return (
      <download-button name={q.format} src={q.src} title={this.$t('media', 'download__download')} />
    );
  }
}
